import axios from "axios";

let isWaking = false;
let pingInterval = null;

// Separate bare instance used only for health pings — not intercepted,
// so it won't trigger server-waking recursively.
const pinger = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  timeout: 5000,
});

function startPinging() {
  if (pingInterval) return;
  pingInterval = setInterval(async () => {
    try {
      await pinger.get("/health");
      markServerReady();
    } catch {
      // still down — keep pinging
    }
  }, 8000);
}

function markServerReady() {
  if (pingInterval) {
    clearInterval(pingInterval);
    pingInterval = null;
  }
  isWaking = false;
  window.dispatchEvent(new Event("server-ready"));
}

export function isServerWaking() {
  return isWaking;
}

export async function retryServerHealth() {
  try {
    await pinger.get("/health");
    markServerReady();
    return true;
  } catch {
    if (!isWaking) {
      isWaking = true;
      window.dispatchEvent(new Event("server-waking"));
    }
    startPinging();
    return false;
  }
}

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 60000,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("wms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (isWaking) {
      markServerReady();
    }
    return response;
  },
  (error) => {
    if (error.code === "ERR_NETWORK" || error.code === "ECONNABORTED") {
      if (!isWaking) {
        isWaking = true;
        window.dispatchEvent(new Event("server-waking"));
        startPinging();
      }
    }
    // Only redirect on actual auth rejection, not network failures
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("wms_token");
      localStorage.removeItem("wms_user");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
